module.exports = __webpack_public_path__ + "1942867313a2eee20283aaf2898bf348.jpg";